export default __webpack_public_path__ + "static/media/Believer's Boots of the Green Ones.b9134845.jpg";